import { Avatar, Container, Box, CardContent, Typography, IconButton, Card, CircularProgress, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { UrlConstant } from "../../../commom/UrlConstant";
import Axios from "../../../config/axios";
import { endLoading, startLoading } from "../../../Redux/loadingSlice";
import { CommonDataTable } from "../SharedComponent/CommonDataTable";
import Yourinvestment from "../Cards/Yourinvestment";
import TotalFunds from "../charts/TotalFund";
import { BookmarkAddOutlined, BookmarkBorderOutlined, BookmarkOutlined, Height, Padding } from "@mui/icons-material";
import { calculateCryptoChange, getCurrentUserId } from "../../../utils/utils";
import Swal from "sweetalert2";
import RightSideSection from "../SharedComponent/RightSideSection";
import Successpopup from "../SharedComponent/Successpopup";
import ThunderIconCirlcle from "../SvgIcons/ThunderIconCirlcle";
import { usePriceFormatter } from "../../../hooks";
import { extractQuoteWithFallback } from "../../../helpers/cryptoQuoteHelper";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { formatPercentage } from "../../../utils/formatting";

type WatchlistStock = {
  type: 'stock';
  icon: string;
  name: string;
  symbol: string;
  price: number;
  changeAmount: number;
  changePercentage: number;
  branding?: any;
  isLoanAvailable: boolean;
};
type WatchlistCrypto = {
  type: 'crypto';
  icon: string;
  name: string;
  symbol: string;
  price: number;
  changeAmount: number;
  changePercentage: number;
  externalID: string;
  isLoanAvailable: boolean;
};
type WatchlistItem = WatchlistStock | WatchlistCrypto;

function WatchList() {
  const dispatch = useAppDispatch();
  const navigation = useNavigate();
  const location = useLocation();
  const { source } = location.state || {};
  const breadcrumbPath = source === "moreOptions" ? "More Options" : "Dashboard";
  // const [setPage] = useState(1);
  const [page, setPage] = useState(1);
  const [rowperpage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState<WatchlistItem[]>([]);
  const [totalRows] = useState(10);
  const [setSearch] = useState("");
  const [added, setadded] = useState(false);
  const listitem = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6]
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false); // State for controlling popup visibility
  const [msg, setmsg] = useState(''); // State for controlling popup visibility
  const [Success, setSuccess] = useState(false); // State for controlling popup visibility
  const [heading, setheading] = useState(''); // State for controlling popup visibility
  const [watchlistFilter, setWatchlistFilter] = useState('all');
  const currencyInfo = useAppSelector((state) => state.currency);
  const currencyKey = currencyInfo.effectiveCurrency || 'USD';
  const formatter = usePriceFormatter()


  console.log(page, rowperpage);

  const navigateToDetail = async (data) => {
    //stockdetail
    navigation("/stockdetail", {
      state: {
        symbol: data.symbol,
        title: "Watchlist",
        icon: data.branding?.icon_url,
      },
    });


  };
  const getWatchList = async () => {
    dispatch(startLoading());
    setLoading(true);
    try {
      const response = await Axios.get(UrlConstant.WachList.GetWatchList);
      const resData = response.data;
      if (resData.result === true) {
        const list = resData.data.map((item) => {
          const isCrypto = item.type === 'crypto';
          if (isCrypto) {
            const quote = extractQuoteWithFallback(item as any, currencyKey);
            const { changeAmount, changePercentage } = quote
              ? calculateCryptoChange(
                quote?.price,
                quote?.percent_change_24h
              )
              : { changeAmount: 0, changePercentage: 0 };
            return {
              type: 'crypto',
              icon: item.logo,
              name: item.name,
              symbol: item.symbol,
              cmcId: item.cmc_id,
              price: item.quote.USD.price,
              changeAmount,
              changePercentage,
              externalID: item.cmc_id,
              isLoanAvailable: item.isLoanAvailable,
            };
          } else {
            return {
              type: 'stock',
              icon: item.branding?.icon_url ?? item.branding?.logo_url,
              name: item.displayName,
              symbol: item.symbol,
              price: item.Last ?? item.stockPrice ?? item.regularMarketPrice,
              changeAmount: item.changeAmount,
              changePercentage: item.changePercentage,
              branding: item.branding,
              isLoanAvailable: item.isLoanAvailable,
            };
          }
        });
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("ERRR : ", error);
      setLoading(false);
    } finally {
      dispatch(endLoading());
    }
  };



  const RemoveWatchList = async (stock) => {
    let symbol = stock.symbol;
    let type = stock.type || 'stock';
    if (type === 'crypto') {
      symbol = stock.cmcId;
    }

    try {
      const response = await Axios.delete(UrlConstant.WachList.RemoveWatchList.replace("{0}", symbol));
      const resData = response.data;
      if (resData.result === true) {
        getWatchList()
        // Swal.fire("Success", resData.msg, "success");
        // setheading('Success')
        // setSuccess(true)
        // setShowPopup(true)
        // setmsg(resData.msg)
      }
      console.log("Success:", resData.msg); // Handle success message or response
    } catch (error) {
      console.error("Error while removing from watchlist:", error);
    } finally {
      dispatch(endLoading());
    }
  };

  const filteredRows: WatchlistItem[] = watchlistFilter === 'all'
    ? rows
    : rows.filter((item) => item.type === watchlistFilter);

  useEffect(() => {
    getWatchList();
  }, []);

  const watchlistVersion = useAppSelector((state) => state.watchlist?.version ?? 0);

  useEffect(() => {
    getWatchList();
  }, [watchlistVersion]);
  //  console.log(rows)
  const closePopup = () => {
    setShowPopup(false); // Function to close the popup
  };
  return (
    <Box
      width='100%'
      className="bg-color "

      sx={{
        display: 'flex',
        minHeight: 'calc(100vh - 251px)',
        height: 'fit-content',
        padding: '30px'
      }}
    >
      <Container style={{ left: "0", height: '100%' }}>
        <Box marginBottom="20px" display="flex" justifyContent="flex-start">
          <ToggleButtonGroup
            value={watchlistFilter}
            exclusive
            onChange={(_, value) => value && setWatchlistFilter(value)}
            aria-label="Watchlist Filter"
            size="small"
          >
            <ToggleButton value="all">All</ToggleButton>
            <ToggleButton value="crypto">Crypto</ToggleButton>
            <ToggleButton value="stock">Stock/ETF</ToggleButton>
          </ToggleButtonGroup>
        </Box>
        <Typography
          className="text-secondary"
          sx={{ marginBottom: "20px" }}
        >
          {" "}
          <span
            onClick={() => navigation(-1)}
            style={{ color: "#4A7AF2", cursor: "pointer" }}
          >
            {breadcrumbPath}{" "}
          </span>{" "}
          / Watchlist
        </Typography>
        <Box marginBottom='20px'>
          <Box display="flex" gap={2} alignItems="center" mb={1}>
            <Typography className="text-white" mb={0} style={{ fontSize: "1.5rem" }}>
              Watchlist
            </Typography>
          </Box>
        </Box>
        <Row className="dark-tbl no-border">
          {loading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="200px"
              bgcolor="transparent"
            >
              <CircularProgress color="primary" />
            </Box>
          ) : filteredRows.length === 0 ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="200px" bgcolor="transparent">
              <Typography className="text-white" sx={{ fontSize: '18px', fontWeight: '700' }}>
                Create a personalized watchlist to easily track your favorite stocks and crypto in real time.
              </Typography>
            </Box>
          ) : (
            <Box display="flex" flexWrap="wrap" gap="10px">
              {filteredRows.map((item, index) => (
                <Card
                  key={index}
                  className="card dcard-hover"
                  sx={{
                    width: '250px', // Responsive widths
                    // height: '116px', // Ensures consistent height
                    display: 'flex',
                    backgroundColor: '#FFFFFF1A !important',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    padding: '15px 20px !important',
                  }}
                  onClick={() => {
                    if (item.type === 'crypto') {
                      navigation("/crypto-detail", { state: { externalID: item.externalID } });
                    } else {
                      navigation("/stockdetail", {
                        state: {
                          symbol: item.symbol,
                          title: "Watchlist",
                          icon: item.icon,
                        },
                      });
                    }
                  }}
                >
                  <CardContent className="text-white" sx={{ padding: '0px !important' }}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb="10px">
                      <Box display="flex" maxWidth="80%" alignItems="center" gap="10px">
                        <Avatar alt={item?.name} src={item?.icon} sx={{ width: 32, height: 32 }} />
                        <Typography
                          variant="body2"
                          sx={{
                            overflow: 'hidden',
                            maxWidth: '110px',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'normal',
                            fontWeight: 'bold',
                          }}
                          fontWeight={600}
                        >
                          {item?.name}
                        </Typography>
                        {item.isLoanAvailable && (
                          <Tooltip title="Booster Loan Eligible" arrow placement="top">
                            <span style={{ marginBottom: '3px' }}>
                              <ThunderIconCirlcle width={16} height={16} />
                            </span>
                          </Tooltip>
                        )}
                      </Box>
                      <IconButton
                        sx={{
                          borderRadius: '10px',
                          paddingRight: '0px',
                          padding: '10px',
                          display: 'flex',
                          justifyContent: 'center',
                          bgcolor: '#4A7AF233',
                          "&:hover": {
                            bgcolor: '#4A7AF233',
                          }
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          RemoveWatchList(item);
                        }}
                      >
                        <BookmarkOutlined style={{ color: '#4A7AF2' }} />
                      </IconButton>
                    </Box>
                    <Typography variant="body1" fontWeight={600}>
                      {formatter.display(item?.price)}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: item.changeAmount >= 0 ? '#4edf6d' : '#ff2a2a' }}
                    >
                      {formatter.display(item.changeAmount, { showSign: true })}
                      ({formatPercentage(
                        item.changeAmount < 0
                          ? -Math.abs(item.changePercentage)
                          : Math.abs(item.changePercentage),
                        { showSign: true }
                      )})
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
          )}
        </Row>
      </Container>

      <Container style={{ width: '440px', padding: '0px' }}>
        <RightSideSection />
      </Container>
      {showPopup && <Successpopup Heading={heading} Success={Success} onClose={closePopup} Message={msg} />}

    </Box>
  );
}
export default WatchList;
